// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-style[data-v-2a1802b9]{cursor:pointer;border-radius:15px;background-size:cover!important;background-position:50%!important;background-repeat:no-repeat!important;height:14rem}", ""]);
// Exports
module.exports = exports;
